<script setup>
import { computed, onMounted, defineProps, ref, defineEmits } from 'vue';

const imagePath = ref("")
const props = defineProps({
    elements: Array,
    resultIsOpen: Boolean
})

const emits = defineEmits(['itemIsClicked','itemIsHover', 'isClicked'])
function mouseEnterEvent(element) {
    if(element.image != undefined && !props.resultIsOpen.value) {
        imagePath.value = element.image
    } else {
        imagePath.value = null
    }
    if(element.hoverEvent != undefined) {
        element.hoverEvent();
    }
    emits('itemIsHover', element)
}

function clickEvent(element) {
    element.clickEvent(element);
    emits('itemIsClicked', element)
}

const openStyle = computed(() => {
        if(props.resultIsOpen === true) {
            return "openResult"
        } else {
            return ""
        }
    //set: () => {}
})
/* const openStyle = computed({
    
    console.log(props.resultIsOpen)
    if(props.resultIsOpen.value === true) {
        return "openResult"
    } else {
        return ""
    }
}) */

const getImage = computed(() => {
    return imagePath.value
})

onMounted(() => {
    if(props.elements.length > 0) {
        imagePath.value = props.elements[0].image
    }
})

function toggleDropdown() {
    emits('isClicked')
}

</script>

<template>
  <div class="controller-result-wrapper" :class="openStyle">
        <div @click="toggleDropdown" class="controllerResults" @scroll="scrolling">
            <div class="results-list d-flex flex-column flex-md-row align-items-center">
                  <div class="imageContainer">
                      <img :src="getImage" alt="" />
                  </div>
                <div class="list-wrapper d-flex flex-column">
                    <div class="pointer " @click="clickEvent(element)" @mouseenter="mouseEnterEvent(element)" v-for="(element, index) of props.elements" :key="index">
                        <div class="itemElement">{{element.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>